// extracted by mini-css-extract-plugin
export default {"ProjectsList":"ProjectsListDark_ProjectsList__506Rh","Container":"ProjectsListDark_Container__ieO5P"};